import { Line } from "@models/line.model";
import { ToolRequest } from "@models/toolRequests.model";
import { User } from "@models/user.model";
import { Tool } from "@app/tool/model/tool.model";
import { Group } from "@app/tool/model/group.model";
import { GroupChildWrapper } from "@app/tool/model/group-child-wrapper.model";
import { Facility } from "@models/facility.model";
import { ToolReturnTypeEnum } from "@models/enums/tool-return-type.enum";

export class ToolReturn {

    public id: number;
    public toolRequest: ToolRequest;
    public line: Line;
    public facility: Facility;
    public createdBy: User;
    public assignedTo: User;
    public createdDate: string;
    public closedDate: string;
    public status: string;
    public returnTools: Tool[];
    public hasSeveralReturnOptions: boolean;
    public reason?: string;
    public maintenanceAtLineTools: Tool[];
    public hasPriority: boolean;
    public type: ToolReturnTypeEnum;
    public mainToolLines: string;

    constructor(toolReturn: any = {}) {
        this.id = toolReturn.id || 0;
        this.toolRequest = new ToolRequest(toolReturn.toolRequest);
        if (toolReturn.line) {
            this.line = new Line(toolReturn.line);
        }
        if (toolReturn.facility) {
            this.facility = new Facility(toolReturn.facility);
        }
        this.createdBy = new User(toolReturn.createdBy);
        this.createdDate = toolReturn.createdDate || '';
        this.closedDate = toolReturn.closedDate || '';
        this.assignedTo = toolReturn.assignedTo ? new User(toolReturn.assignedTo) : new User();
        this.status = toolReturn.status || '';
        this.returnTools = this.mapGroupableItems(toolReturn.returnTools);
        this.hasSeveralReturnOptions = toolReturn.hasSeveralReturnOptions || false;
        this.reason = toolReturn.reason;
        this.maintenanceAtLineTools = this.mapGroupableItems(toolReturn.maintenanceAtLineTools);
        this.hasPriority = toolReturn.priority === 1;
        this.type = toolReturn.type ? toolReturn.type as ToolReturnTypeEnum : null;
        this.mainToolLines = toolReturn.mainToolLines || '';
    }

    mapGroupableItems(items) {
        if (items) {
            const groups = items.items.map(group => {
                if (group.subGroup) {
                    return new Group(group);
                }
                return new GroupChildWrapper(group).item;
            });
            return groups;
        }
        return [];
    }
}
